<script>

import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
	
	components: {
		HeaderComponent: () => import('../components/HeaderComponent.vue'),
		MenuComponent: () => import('../components/layout/MenuComponent.vue'),
		DraggableDiv: () => import('../components/DraggableDiv.vue'),
	},
	data() {
		return {
			progressLoaded: false,
			files: [
				{
					name: 'Bastanteo',
					type: 'pdf',
					src: '/expediente/soriano/Bastanteo.pdf'
				},
				{
					name: 'Buró de Crédito_Alberto Rementería PF',
					type: 'pdf',
					src: '/expediente/soriano/Buro_de_Credito_Alberto_Rementeria_PF.pdf'
				},
				{
					name: 'Buró de Crédito_Alberto Rementería PM',
					type: 'pdf',
					src: '/expediente/soriano/Buro_de_Credito_Alberto_Rementeria_PM.pdf'
				},
				{
					name: 'Buró de Crédito_Sergio Ayala PF',
					type: 'pdf',
					src: '/expediente/soriano/Buro_de_Credito_Sergio_Ayala_PF.pdf'
				},
				{
					name: 'Buró de Crédito_Sergio Ayala PM',
					type: 'pdf',
					src: '/expediente/soriano/Buro_de_Credito_Sergio_Ayala_PM.pdf'
				},
				{
					name: 'EEFF 2020 Soriano',
					type: 'pdf',
					src: '/expediente/soriano/EEFF_2020_Soriano.pdf'
				},
				{
					name: 'EEFF Cambio a 2018 y 2019',
					type: 'pdf',
					src: '/expediente/soriano/EEFF_Cambio_a_2018_y_2019.pdf'
				},
				{
					name: 'Identificación Apoderado',
					type: 'pdf',
					src: '/expediente/soriano/Identificacion_Apoderado.pdf'
				},
				{
					name: 'Identificación Aval',
					type: 'pdf',
					src: '/expediente/soriano/Identificacion_Aval.pdf'
				},
				{
					name: 'Relaciones Patrimoniales',
					type: 'pdf',
					src: '/expediente/soriano/Relaciones_Patrimoniales.pdf'
				},
				{
					name: 'Reporte vista fotográfico',
					type: 'pdf',
					src: '/expediente/soriano/Reporte_vista_fotografico.pdf'
				},
				{
					name: 'Riesgos globlales',
					type: 'pdf',
					src: '/expediente/soriano/Riesgos_globlales.pdf'
				},
				{
					name: 'Verificación de Propiedad SA',
					type: 'pdf',
					src: '/expediente/soriano/Verificacion_de_Propiedad_SA.pdf'
				},
				{
					name: 'Verificación de Propiedad',
					type: 'pdf',
					src: '/expediente/soriano/Verificacion_de_Propiedad.pdf'
				},
				{
					name: 'Verificación de Sociedad',
					type: 'pdf',
					src: '/expediente/soriano/Verificacion_de_Sociedad.pdf'
				},
			
			],
			selectedFile: null,
			selectedFilePF: null,
		}
	},
	computed: {
		modal() {
			return this.$route.params.modal
		},
		...mapGetters({
			userId: 'auth/userId',
			activityById: 'activities/byId',
			filesPF: 'pfStatus/files',
		})
	},

	async mounted() {
		this.progressLoaded = await this.getUserProgress(this.userId)
		if(this.$route.query.test) {
			this.$store.commit('auth/setTest', true)
		}
	},

	methods: {
		showVideo() {
			const vm = this
			vm.$refs.videoStart.show()
		},
		selectFile(file) {
			this.$set(this, 'selectedFile', file)
			let $pdf = document.getElementById('filereader')
			document.getElementById('filesRespo').classList.add('read-mode')
			if(document.getElementById('btnFiles').dataset.show) {
				document.getElementById('filesRespo').classList.add('simulador-open')
			}
			// $pdf.window.eval('document.addEventListener("contextmenu", function (e) {e.preventDefault();}, false)')
		},
		selectFilePF(file) {
			this.$set(this, 'selectedFilePF', file)
			let $pdf = document.getElementById('filereader')
			document.getElementById('filesRespoPF').classList.add('read-mode')
			if(document.getElementById('btnFiles').dataset.show) {
				document.getElementById('filesRespoPF').classList.add('simulador-open')
			}
			// $pdf.window.eval('document.addEventListener("contextmenu", function (e) {e.preventDefault();}, false)')
		},
		showFiles() {
			document.getElementById('filesRespo').classList.toggle('active')
			let $drag = document.querySelector('#filesRespo .draggable-container')
			$drag.style.top = 0
			$drag.style.left = 0
			if(this.$route.params.module == 3) {
				this.setCurrentClientPF(localStorage.caseFileClient || 1)
			}
		},
		showFilesPF() {
			document.getElementById('filesRespoPF').classList.toggle('active')
			this.setCurrentClientPF(localStorage.caseFileClient || 1)
			let $drag = document.querySelector('#filesRespoPF .draggable-container')
			$drag.style.top = 0
			$drag.style.left = 0
		},
		closeFiles() {
			document.getElementById('filesRespo').classList.remove('active')
			let $drag = document.querySelector('#filesRespo .draggable-container')
			$drag.style.top = 0
			$drag.style.left = 0
		},
		closeFilesPF() {
			document.getElementById('filesRespoPF').classList.remove('active')
			let $drag = document.querySelector('#filesRespoPF .draggable-container')
			$drag.style.top = 0
			$drag.style.left = 0
		},
		
		...mapMutations({
			setCurrentClientPF: 'pfStatus/setCurrentClient'
		}),
		...mapActions({
			getUserProgress: 'auth/getUserProgress'
		})
	},
	
	

}
</script>

<template>
	<div class="bg-menu">
		<HeaderComponent/>
		<MenuComponent/>
		<div v-if="progressLoaded" class="menu__router">
			<router-view />
		</div>
		<div class="simulator__view" id="simulatorArceHelp">
			<iframe :src="`/index.html?v=7781/#/simulator/f/arce/help?v=30092022_1605`" frameborder="0"></iframe>
		</div>
		<div class="simulator__view" id="simulatorArce">
			<iframe :src="`/index.html?v=7781/#/simulator/f/arce?v=30092022_1605`" frameborder="0"></iframe>
		</div>
		<div class="simulator__view" id="simulatorPFHelp">
			<iframe :src="`/index.html?v=7781/#/simulator/f/pf/help?v=30092022_1605`" frameborder="0"></iframe>
		</div>
		<div class="simulator__view" id="simulatorPF">
			<iframe :src="`/index.html?v=7781/#/simulator/f/pf?v=30092022_1605`" frameborder="0"></iframe>
		</div>
		<template v-if="$route.params.hasOwnProperty('module') && $route.name == 'formation-activity'">
			<div id="filesRespo" class="files-repo" v-if="$route.params.module == 2">
				<DraggableDiv class="files-repo__drag">
					<template slot="header">
						<div class="files-repo__header py-2 px-3 s">
							<h6 class="m-0">Expediente Soriano</h6> <button class="files-repo__close" @click="closeFiles"><i class="fa fa-times" aria-hidden="true"></i></button>
						</div>
					</template>
					<template slot="main">
						<div class="files-repo__body position-relative h-100 flex-grow-1">
							<ul v-if="!selectedFile" class="d-flex flex-wrap files-list">
								<li class="files-list__item col-6 p-1" v-for="(file, index) in files" :key="`file_${index}`" >
									<div class="files-list__item-name d-flex" @click="selectFile(file)">
										<span class="pr-1 my-auto">
											<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
										</span>
										<span>
										{{ file.name }}
										</span>
									</div>
								</li>
							</ul>
							<div class="position-absolute w-100 h-100 d-flex"  v-else>
								<div class="col-2 p-0 h-100 overflow-auto">
									<ul class="d-flex flex-wrap files-list">
										<li class="files-list__item col-12 p-1" v-for="(file, index) in files" :key="`file_${index}`">
											<div class="files-list__item-name d-flex" :class="{'selected': file.src == selectedFile.src}"  @click="selectFile(file)">
												<span class="pr-1 my-auto">
													<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
												</span>
												<span>
												{{ file.name }}
												</span>
											</div>
										</li>
									</ul>
								</div>
								<iframe id="filereader" class="col-10 p-0 h-100" :src="`${selectedFile.src}#toolbar=0`" type="">
								</iframe>
							</div>
						</div>
					</template>
					<template slot="footer">
					</template>
				</DraggableDiv>
			</div>
			<button v-if="$route.params.module == 2" id="btnFiles" @click="showFiles" class="btn-files"><i class="fa fa-folder" aria-hidden="true"></i>
				<span class="btn-files__label">Expediente Soriano</span>
			</button>
			<div id="filesRespoPF" class="files-repo" v-if="$route.params.module == 3" >
				<DraggableDiv class="files-repo__drag">
					<template slot="header">
						<div id="filesRespoPFheader" class="files-repo__header py-2 px-3 s">
							<h6 class="m-0">Expediente {{filesPF.name}}</h6> <button class="files-repo__close" @click="closeFilesPF"><i class="fa fa-times" aria-hidden="true"></i></button>
						</div>
					</template>
					<template slot="main">
						<div class="files-repo__body position-relative h-100 flex-grow-1">
							<div v-if="!selectedFilePF">
								<div v-if="filesPF.files.buros.length" class="mb-3">
									<h6>Buros</h6>
									<ul class="d-flex flex-wrap files-list">
										<li class="files-list__item col-6 p-1" v-for="(file, index) in filesPF.files.buros" :key="`file_${index}`" >
											<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
												<span class="pr-1 my-auto">
													<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
												</span>
												<span>
												{{ file.name }}
												</span>
											</div>
										</li>
									</ul>
								</div>
								<div v-if="filesPF.files.eeff.length" class="mb-3">
									<h6>EEFF SINTESIS FINANCIERA CREDITLENS/ARCE CORPORATE​</h6>
									<ul class="d-flex flex-wrap files-list">
										<li class="files-list__item col-6 p-1" v-for="(file, index) in filesPF.files.eeff" :key="`file_${index}`" >
											<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
												<span class="pr-1 my-auto">
													<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
												</span>
												<span>
												{{ file.name }}
												</span>
											</div>
										</li>
									</ul>
								</div>
								<div v-if="filesPF.files.general.length" class="mb-3">
									<h6>General</h6>
									<ul class="d-flex flex-wrap files-list">
										<li class="files-list__item col-6 p-1" v-for="(file, index) in filesPF.files.general" :key="`file_${index}`" >
											<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
												<span class="pr-1 my-auto">
													<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
												</span>
												<span>
												{{ file.name }}
												</span>
											</div>
										</li>
									</ul>
								</div>
								<div v-if="filesPF.files.ra.length" class="mb-3">
									<h6>Creditlens/ARCE Corporate​</h6>
									<ul class="d-flex flex-wrap files-list">
										<li class="files-list__item col-6 p-1" v-for="(file, index) in filesPF.files.ra" :key="`file_${index}`" >
											<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
												<span class="pr-1 my-auto">
													<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
												</span>
												<span>
												{{ file.name }}
												</span>
											</div>
										</li>
									</ul>
								</div>
							</div>
							<div class="position-absolute w-100 h-100 d-flex"  v-else>
								<div class="col-2 p-0 h-100 overflow-auto">
									<div v-if="filesPF.files.buros.length" class="mb-3">
										<h6>Buros</h6>
										<ul class="d-flex flex-wrap files-list">
											<li class="files-list__item col-12 p-1" v-for="(file, index) in filesPF.files.buros" :key="`file_${index}`" >
												<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
													<span class="pr-1 my-auto">
														<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
													</span>
													<span>
													{{ file.name }}
													</span>
												</div>
											</li>
										</ul>
									</div>
									<div v-if="filesPF.files.eeff.length" class="mb-3">
										<h6>EEFF</h6>
										<ul class="d-flex flex-wrap files-list">
											<li class="files-list__item col-12 p-1" v-for="(file, index) in filesPF.files.eeff" :key="`file_${index}`" >
												<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
													<span class="pr-1 my-auto">
														<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
													</span>
													<span>
													{{ file.name }}
													</span>
												</div>
											</li>
										</ul>
									</div>
									<div v-if="filesPF.files.general.length" class="mb-3">
										<h6>General</h6>
										<ul class="d-flex flex-wrap files-list">
											<li class="files-list__item col-12 p-1" v-for="(file, index) in filesPF.files.general" :key="`file_${index}`" >
												<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
													<span class="pr-1 my-auto">
														<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
													</span>
													<span>
													{{ file.name }}
													</span>
												</div>
											</li>
										</ul>
									</div>
									<div v-if="filesPF.files.ra.length" class="mb-3">
										<h6>RA</h6>
										<ul class="d-flex flex-wrap files-list">
											<li class="files-list__item col-12 p-1" v-for="(file, index) in filesPF.files.ra" :key="`file_${index}`" >
												<div class="files-list__item-name d-flex" @click="selectFilePF(file)">
													<span class="pr-1 my-auto">
														<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
													</span>
													<span>
													{{ file.name }}
													</span>
												</div>
											</li>
										</ul>
									</div>
									<!-- <ul class="d-flex flex-wrap files-list">
										<li class="files-list__item col-12 p-1" v-for="(file, index) in files" :key="`file_${index}`">
											<div class="files-list__item-name d-flex" :class="{'selected': file.src == selectedFile.src}"  @click="selectFile(file)">
												<span class="pr-1 my-auto">
													<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
												</span>
												<span>
												{{ file.name }}
												</span>
											</div>
										</li>
									</ul> -->
								</div>
								<iframe id="filereader" class="col-10 p-0 h-100" :src="`${filesPF.base_path}${selectedFilePF.src}#toolbar=0`" type="">
								</iframe>
							</div>
						</div>
					</template>
					<template slot="footer">
					</template>
				</DraggableDiv>
			</div>
			<button v-if="$route.params.module == 3" id="btnFiles" @click="showFilesPF" class="btn-files"><i class="fa fa-folder" aria-hidden="true" ></i>
				<span class="btn-files__label">Expediente {{filesPF.name}}</span>
			</button>
		</template>
		
	</div>
</template>
<style lang="scss" scoped>
.btn-files{
	position: fixed;
    bottom: 0.25rem;
    left: 95px;
    display: inline-block;
    width: 3rem;
    height: 3rem;
    background-color: #2DCCCD;
    color: #fff;
    z-index: 100;
    border-radius: 50%;
    border: 0 none;
	box-shadow: 0 0 20px #2DCCCD4f;
	transition: 0.3s;
	outline: none !important;
	&.simulador-open{
		bottom: 3.5rem;
		right: 1rem;
		.btn-files{
			&__label{
				transform: translateY(-50%) scaleX(0);
				opacity: 0;
			}
		}
		&:hover{
			.btn-files{
				&__label{
					transform: translateY(-50%) scaleX(1);
					opacity: 1;
				}
			}
		}
	}
	&__label{
		background-color: #2DCCCD;
		color: #fff;
		display: inline-block;
		position: absolute;
		padding: 0.1rem 1rem;
		white-space: nowrap;
		left: 90%;
		font-size: 0.8em;
		border-radius: 0 30px 30px 0;
		top: 50%;
		transform: translateY(-50%);
		transition: 0.3s;
		transform-origin: left center;
	}
}
.files-list{
	list-style: none;
	padding: 0;
	margin: 0;
	&__item{
		padding: 0.5em;
		font-size: 0.65em;
		&-name{
			border: 1px solid rgb(192, 192, 192);
			border-radius: 0.25rem;
			padding: 0.5rem;
			cursor: pointer;
			transition: 0.3s;
			&.selected{
				border-color: #6d6d6d;
				background-color: #eee;
			}
			&:hover{
				box-shadow: 0 0 5px rgba($color: #000000, $alpha: 0.3);
				border-color: #6d6d6d;
			}
			.fa{
				color: crimson;
				font-size: 1.5em;
			}
		}
	}
}
.files-repo{
	width: 1px;
	min-width: 1px;
	position: fixed;
	height: 90vh;
	bottom: 56px;
	background: transparent;
	left: -1300px;
	opacity: 0;
	transition: 0.3s;
	display: flex;
	flex-direction: column;
	transform: translateX(-100%);
	z-index: 99;
	&__drag{
		width: 30vw;
		min-width: 300px;
		height: 100%;
		box-shadow: 0 0 15px rgba($color: #000000, $alpha: 0.3);
	}
	&.simulador-open{
		bottom: 35px;

	}
	&.read-mode{
		.files-repo{
			&__drag{
				width: 60vw;
			}
		}
	}
	&.active{

		opacity: 1;
		left: 90px;
		transform: translateX(0%);

	}
	&__close{
		position: absolute;
		color: #ffff;
		background-color: transparent;
		border: 0 none;
		outline: none !important;
		right: 0.5rem;
		top: 50%;
		transform: translateY(-50%);
	}

	
	
	&__header{
		background-color: #022857;
		background-image: url('../assets/img/bg_menu.jpg');
		background-position: bottom left;
		background-size: cover;
		color: #fff;
		position: relative;
	}
	&__body{
		border-left: 10px solid #022857;
		border-right: 10px solid #022857;
		border-bottom: 10px solid #022857;
		flex-grow: 1;
		height: 50%;
		background-color: #fff;
	}
}
.menu{
	&__router{
		height: 50%;
		flex-grow: 1;
		overflow: hidden;
	}
}
</style>
